/**
 * Resolves a trikot image path to an absolute path
 * @param {string} imagePath - The image path from the database
 * @returns {string} The resolved image path
 */
export const resolveTrikotImagePath = (imagePath) => {
  if (!imagePath) {
    return null;
  }

  // If the path is already a full URL, return it as is
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  // If the path already starts with a slash, return it as is
  if (imagePath.startsWith("/")) {
    return imagePath;
  }

  // Otherwise, add a leading slash to make it relative to the public directory
  // In React, files in the public folder are served from the root
  return `/${imagePath}`;
};
